module.exports = __webpack_public_path__ + "media/base/builder_tool_big-1fb87d7a.svg";